<!-- The panel supplies the chevron, the header button and the
     expanded/collapsed announcement, so none of that is hand-rolled here.
     The `rds-accordion` wrapper is not optional decoration: RDS scopes every
     panel rule under `.rds-accordion`, so a bare panel renders unstyled — its
     header loses its padding entirely. -->
<rds-accordion class="assistant-widget">
  <rds-expansion-panel
    togglePosition="after"
    [expanded]="isExpanded()"
    (expandedChange)="isExpanded.set($event)"
  >
    <rds-expansion-panel-header>
      <rds-panel-title>
        <span class="assistant-widget-title ui-label-l-bold">
          <inexp-sparkle-icon />
          Panorama AI
        </span>
      </rds-panel-title>
    </rds-expansion-panel-header>

    <div class="assistant-widget-body">
      <!-- Not a live region: the summary streams token by token, and every
           token would interrupt the previous announcement. A screen reader
           hears the short status below instead, and can read the finished
           summary as ordinary content. -->
      <div class="assistant-widget-summary">
        @if (isStreaming() && !summary()) {
          <span class="assistant-widget-thinking">
            <rds-progress-spinner size="s" />
            Reading the catalog…
          </span>
        }
        @if (summary()) {
          <!-- The directive delegates clicks on the offering links the pipe
               generates: anchors from `[innerHTML]` get no Angular bindings, so
               without it they would navigate as a full page reload. -->
          <div
            class="inexp-markdown"
            inexpOfferingLinks="assistant widget"
            [innerHTML]="summary() | markdown: summaryLinks()"
          ></div>
        }
      </div>

      <p class="sr-only" role="status">
        @if (isStreaming()) {
          Panorama AI is reading the catalog…
        }
      </p>

      <!-- Say the summary failed rather than leaving a blank panel. The ask row
           below still works, so this is a partial failure, not a dead widget. -->
      @if (hasFailed()) {
        <p class="assistant-widget-failed" role="alert">
          Panorama AI could not summarise this right now — you can still ask a
          question below.
        </p>
      }

      <inexp-search-input
        class="full-width"
        [placeholder]="followUpPlaceholder()"
        buttonText="Ask Panorama"
        [showAutocomplete]="false"
        [isSearchEnabled]="true"
        (searchSubmit)="ask($event)"
      >
        <inexp-sparkle-icon searchButtonIcon />
      </inexp-search-input>
    </div>
  </rds-expansion-panel>
</rds-accordion>
